import SendEmail from './SendEmailContainer';

export default SendEmail;
